import apiClient from '../utils/apiClient';

const base = (facilityId) => `/api/facilities/${facilityId}/payments`;

const paymentsService = {
  getAll: (facilityId) => apiClient.get(`${base(facilityId)}/`),
  getById: (facilityId, id) => apiClient.get(`${base(facilityId)}/${id}`),
  create: (facilityId, data) => apiClient.post(`${base(facilityId)}/`, data),
  update: (facilityId, id, data) => apiClient.patch(`${base(facilityId)}/${id}`, data),
  remove: (facilityId, id) => apiClient.delete(`${base(facilityId)}/${id}`),
};

export default paymentsService;
